import SvgIcon, {type SvgIconProps} from '@mui/material/SvgIcon';

const BookmarkFilled = (props : SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70">
      <g id="picto" transform="translate(-668 -150)">
        <circle id="bg" cx="35" cy="35" r="35" transform="translate(668 150)" fill="#f1c40f"/>
        <path id="star" d="M20.3,2l5.655,11.456L38.6,15.3l-9.15,8.912,2.159,12.59L20.3,30.859,8.99,36.806l2.159-12.59L2,15.3l12.645-1.848Z" transform="translate(682.7 165.597)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
      </g>
    </svg>
  </SvgIcon>
);

export default BookmarkFilled;